import { useTranslationLabel } from "../hooks/useTranslationLabel"
import { ROUTES } from "./routes.const"

export type HeaderLink = {
  label: string
  path: string
}

export const useHeaderLinks = (): HeaderLink[] => {
  const {
    HEADER_MY_PROFILE,
    HEADER_MONTHLY_SUMMARY,
    HEADER_MY_RIDES,
    HEADER_NEW_RESERVATION,
  } = useTranslationLabel()
  return [
    { label: HEADER_MY_RIDES, path: ROUTES.MY_RIDES },
    // { label: HEADER_MONTHLY_SUMMARY, path: ROUTES.MONTHLY_SUMMARY },
    { label: HEADER_MY_PROFILE, path: ROUTES.PROFILE },
    // { label: HEADER_NEW_RESERVATION, path: ROUTES.NEW_RESERVATION },
  ]
}
